import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MountainViewIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MountainViewIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M4.96876 10.2422H2.58594C2.26235 10.2422 2 10.5045 2 10.8281C2 11.1517 2.26234 11.4141 2.58594 11.4141H4.96876C5.29235 11.4141 5.5547 11.1517 5.5547 10.8281C5.5547 10.5045 5.29236 10.2422 4.96876 10.2422Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.2031 10.2422H17.8594C17.5358 10.2422 17.2734 10.5045 17.2734 10.8281C17.2734 11.1517 17.5358 11.4141 17.8594 11.4141H20.2031C20.5267 11.4141 20.7891 11.1517 20.7891 10.8281C20.7891 10.5045 20.5267 10.2422 20.2031 10.2422Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.0433 4.19896C17.8145 3.97013 17.4435 3.97013 17.2146 4.19896L15.5574 5.85623C15.3285 6.08506 15.3285 6.45604 15.5574 6.68486C15.7862 6.91369 16.1572 6.91373 16.386 6.68486L18.0433 5.02759C18.2721 4.79872 18.2721 4.42775 18.0433 4.19896Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.27081 5.85626L5.6135 4.19899C5.38471 3.97012 5.01369 3.97012 4.7849 4.19899C4.55607 4.42782 4.55607 4.7988 4.7849 5.02762L6.44217 6.68489C6.67096 6.91372 7.04198 6.91376 7.2708 6.68489C7.49963 6.45606 7.49964 6.08508 7.27081 5.85626Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.4141 1.99999C11.0905 1.99999 10.8281 2.26233 10.8281 2.58593V4.96875C10.8281 5.29234 11.0905 5.55469 11.4141 5.55469C11.7377 5.55469 12 5.29235 12 4.96875V2.58593C12 2.26234 11.7377 1.99999 11.4141 1.99999Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.898 21.0837L15.9903 12.4317C16.064 12.0989 16.1016 11.7579 16.1016 11.4141C16.1016 8.82937 13.9988 6.72655 11.4141 6.72655C8.82938 6.72655 6.72656 8.82937 6.72656 11.4141C6.72656 12.4299 7.04621 13.3965 7.65098 14.2095C8.08946 14.7989 8.64786 15.2687 9.2902 15.5943L7.76684 17.8793L6.60938 16.3359C6.49879 16.1885 6.32532 16.1017 6.14102 16.1016C5.95688 16.1016 5.78305 16.1881 5.67235 16.3353L2.11766 21.0619C1.98418 21.2393 1.9625 21.477 2.06168 21.6758C2.16086 21.8745 2.36387 22 2.58594 22H21.4141C21.6314 22 21.8308 21.8798 21.9322 21.6877C22.0337 21.4956 22.0205 21.2631 21.898 21.0837ZM7.89844 11.4141C7.89844 9.47554 9.47555 7.89843 11.4141 7.89843C13.143 7.89843 14.5843 9.15292 14.8758 10.7995L14.8277 10.7289C14.7185 10.5689 14.5373 10.4734 14.3438 10.4734H14.3405C14.1458 10.4744 13.9643 10.5722 13.8563 10.7343L11.4908 14.2828L11.3165 14.02C11.2081 13.8565 11.0251 13.7581 10.8289 13.7579C10.633 13.7579 10.4493 13.8557 10.3407 14.0188L9.94626 14.6104C8.70563 14.0436 7.89844 12.808 7.89844 11.4141ZM3.75976 20.8281L6.14 17.6632L7.32629 19.2449C7.44039 19.3971 7.62149 19.4842 7.81129 19.4791C8.00137 19.4738 8.17707 19.3766 8.28258 19.2184L10.8268 15.4021L14.4242 20.8281H3.75976ZM15.8302 20.8281L12.193 15.342L14.3496 12.1069C14.7875 12.7483 19.9958 20.3761 20.3045 20.8282L15.8302 20.8281Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default MountainViewIcon;
